/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Collection list
  var init = false;
  var swiper;

  if (!init) {
    init = true;
    window.addEventListener('load', function () {
      swiper = new Swiper('.featured-collection-slider', {
        // Optional parameters
        slidesPerView: 1.15,
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          320: {
            loop: true,
            slidesPerView: 1.15,
            spaceBetween: 15,
          },

          640: {
            loop: true,
            slidesPerView: 2.15,
            spaceBetween: 20,
          },

          1024: {
            slidesPerView: 3.15,
            spaceBetween: 5,
          },
        },
      });
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  // Size guide
  document.querySelectorAll('scroll-link').forEach(function (element) {
    element.preventDefault();
    element.addEventListener('click', function () {
      const targetDiv = document.getElementByID('table-ring');
      targetDiv.scrollIntoView({ behavior: 'smooth' });
    });
  });

  document.querySelectorAll('scroll-size').forEach(function (element) {
    element.preventDefault();
    element.addEventListener('click', function () {
      const targetSize = document.getElementByID('table-bangle');
      targetSize.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // Gift card

  const moreOptionButton = document.querySelector('.giftcard-more-option');

  if (moreOptionButton) {
    moreOptionButton.addEventListener('click', function () {
      document.querySelectorAll('.radio__button.hide-mobile').forEach(function (button) {
        button.classList.remove('hide-mobile');
      });

      this.classList.add('hidden');
    });
  }
})();
